import DiscountGoods from './discount_goods.vue';

export default DiscountGoods;
